import { render, staticRenderFns } from "./WholeSaleGoodsItem.vue?vue&type=template&id=40956adc&scoped=true&"
import script from "./WholeSaleGoodsItem.vue?vue&type=script&lang=js&"
export * from "./WholeSaleGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./WholeSaleGoodsItem.vue?vue&type=style&index=0&id=40956adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40956adc",
  null
  
)

export default component.exports